module.exports = __webpack_public_path__ + "media/images/new/icons/facebook-2976b2e853d1b59d57a0b12f39dda199.png";